import React from 'react';
import styles from './profile-details.module.scss';
import { ProfileInfo } from './profile-details.interface';
import { phoneMask } from '../../utils/const';

const ProfileDetails: React.FC<ProfileInfo> = ({ user }) => {
  const { firstName, lastName, email, number } = user || {};

  return (
    <div className={styles.profile}>
      {firstName && (
        <div className={styles.profileBox}>
          <label>{'First Name'}</label>
          <p>{firstName}</p>
        </div>
      )}

      {lastName && (
        <div className={styles.profileBox}>
          <label>{'Last Name'}</label>
          <p>{lastName}</p>
        </div>
      )}

      {email && (
        <div className={styles.profileBox}>
          <label>{'Email Address'}</label>
          <p>{email}</p>
        </div>
      )}
      {number && (
        <div className={styles.profileBox}>
          <label>{'Mobile Number'}</label>
          <p>{phoneMask(Number(number))}</p>
        </div>
      )}
    </div>
  );
};

export default React.memo(ProfileDetails);
